import { SalvusHealthAuthentication } from "@/models/nvpair/SalvusHealthAuthentication";

export class SalvusHealthAuthentications {

    constructor(
        public authentications: SalvusHealthAuthentication[],
    ) {}

    public hasAuthentications(): boolean {
        return this.authentications.length > 0;
    }

    public getAuthentication(apbNumber: string): SalvusHealthAuthentication | null {
        return this.authentications.find(auth => auth.apb_number === apbNumber) ?? null;
    }

    public getAuthenticationsForSelect(): object[] {
        const map: object[] = [];
        this.authentications.forEach(auth => map.push({code: auth.apb_number, description: auth.apb_number}));

        return map;
    }
}
